import axios from '@/plugins/axios'
import * as actionTypes from '@/store/action-types'
import { DashboardData } from '@/model/dashboard/DashboardData'
import { GlobalState } from '@/types'

const dashboardModule = {
  actions: {
    async [actionTypes.FETCH_DASHBOARD_DATA] (): Promise<Array<DashboardData>> {
      const response = await axios.get('/api/Dashboard/Get')

      return DashboardData.createListFromResponse(response.data)

    },

    async [actionTypes.UPDATE_DASHBOARD_SETTINGS] ({ rootState }: { rootState: GlobalState }, payload: any) {
      const response = await axios.post('/api/Dashboard/Save', payload)

      return response.data
    },

    async [actionTypes.RESET_DASHBOARD_SETTINGS] () {
      const response = await axios.post('/api/Dashboard/Reset', null)

      return response.data
    }

  }
}

export default dashboardModule

